import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { delay } from "../../helper/delayresponse";
import { number } from "yup";

export interface SmsCampaignWiseReport {
    id?: number;
    message_type: string;
    from?: string;
    to?: string;
    direction?: string;
    media_url?: string;
    message?: string;
    status?: number;
    sms_gateway_name?: string;
    retry_sms_id: number;
    error_code: string | null;
    error_message: string | null;
    createdAt: string;
    user: string | null;
}

interface SmsCampaignWiseState {
    smscampaignwisereportdata: SmsCampaignWiseReport[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

interface SmsCampaignListParams {
    id: number;
    message_type?: string;
    from?: string;
    to?: string;
    direction?: string;
    media_url?: string;
    message?: string;
    sort?: 'ASC' | 'DESC';
    status?: string;
    limit: number;
    page: number;
    sort_field: string
    sms_gateway_name: string;
    retry_sms_id?: number;
    error_code: string;
    from_date: string;
    to_date: string;
    username: string;
    useremail: string;
    userrole: string;
    user_id:string
}

interface SmsCampaignListResponse {
    data: SmsCampaignWiseReport[];
    info: {
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    };
}

export const GetallSmsCampaignWiseReport = createAsyncThunk<
    SmsCampaignListResponse,
    SmsCampaignListParams,
    { rejectValue: string }
>(
    'GetallSmsCampaignWiseReport',
    async (params, { rejectWithValue }) => {
        try {
            await delay(500)
            const response = await axiosInstance.get(`/api/admin/reports/campaign-wise-reports/${params.id}`, {
                params: {
                    message_type: params.message_type,
                    from: params.from,
                    to: params.to,
                    direction: params.direction,
                    status: params.status,
                    sms_gateway_name: params.sms_gateway_name,
                    retry_sms_id: params.retry_sms_id,
                    error_code: params.error_code,
                    from_date: params.from_date,
                    to_date: params.to_date,
                    "user.name": params.username,
                    "user.email": params.useremail,
                    "user.role": params.userrole,
                    "user.id":params.user_id,
                    sort_field: params.sort_field,
                    sort: params.sort,
                    page: params.page,
                    limit: params.limit
                }
            });
            return { data: response.data.data, info: response.data.info };
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);


const initialState: SmsCampaignWiseState = {
    smscampaignwisereportdata: [],
    info: null,
    error: null,
    loading: false,
};

const smscampaignwisereportsSlice = createSlice({
    name: "Smscampaignwisereport",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-smscampaign-wise-slice-start============
            .addCase(GetallSmsCampaignWiseReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallSmsCampaignWiseReport.fulfilled, (state, action: PayloadAction<{ data: SmsCampaignWiseReport[], info: { count: number; current_page: number; limit: number; total_page: number } }>) => {
                state.loading = false;
                state.smscampaignwisereportdata = action.payload.data;
                state.info = action.payload.info;
            })
            .addCase(GetallSmsCampaignWiseReport.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-smscampaign-wise-end============
    },
});

export default smscampaignwisereportsSlice.reducer;
